import { Spinner } from "./types";

const defaultState = {
    isOpen: false,
    options: {
        spinnerType: null,
    },
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case Spinner.OPEN:
            return {
                ...state,
                isOpen: true,
                options: {
                    ...defaultState.options,
                    ...action.options,
                },
            };

        case Spinner.CLOSE:
            if (
                (!action.options.spinnerType && !state.options.spinnerType) ||
                action.options.spinnerType === state.options.spinnerType
            ) {
                return {
                    ...state,
                    isOpen: false,
                    options: { ...defaultState.options },
                };
            }
            return state;

        default:
            return state;
    }
};
